import { render, staticRenderFns } from "./ModalConfirmarPreviaCirurgica.vue?vue&type=template&id=6aa80fc5&scoped=true"
import script from "./ModalConfirmarPreviaCirurgica.vue?vue&type=script&lang=ts"
export * from "./ModalConfirmarPreviaCirurgica.vue?vue&type=script&lang=ts"
import style0 from "./ModalConfirmarPreviaCirurgica.vue?vue&type=style&index=0&id=6aa80fc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa80fc5",
  null
  
)

export default component.exports